import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type IndustryFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<IndustryFormSchema> = {
  id: -1,
  name: '',
  description: '',
  consumer_label: '',
  parent: null,
  status: defaultStatus,
} as const;

export const breadcrumbsLinks: RouteListItem[] = [settingsBcLink, { path: '/settings/industries', name: 'Industries' }];
